exports.getCurrentPath = function(routing) {
  return (routing && routing.location) ? routing.location.pathname : '';
}

exports.padZero = function(value) {
	return Number(value) < 10 ? `0${value}` : `${value}`;
}


// WEBPACK FOOTER //
// ./src/app/utils/index.js